/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import GeoLocationController from "./geo-location.controller";
import GeoLocationDirective from './geo-location.directive';
import GeoLocationRoutes from './geo-location.routes';

export default angular.module('tektelic.geoLocation', [])
    .config(GeoLocationRoutes)
    .controller('GeoLocationController', GeoLocationController)
    .directive('tkGeolocation', GeoLocationDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/geo-location/index.js